/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteAssistantSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAssistantRequest = {
  /**
   * The assistant ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteAssistantSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAssistantSecurity$outboundSchema: z.ZodMiniType<
  DeleteAssistantSecurity$Outbound,
  DeleteAssistantSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAssistantSecurityToJSON(
  deleteAssistantSecurity: DeleteAssistantSecurity,
): string {
  return JSON.stringify(
    DeleteAssistantSecurity$outboundSchema.parse(deleteAssistantSecurity),
  );
}

/** @internal */
export type DeleteAssistantRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteAssistantRequest$outboundSchema: z.ZodMiniType<
  DeleteAssistantRequest$Outbound,
  DeleteAssistantRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteAssistantRequestToJSON(
  deleteAssistantRequest: DeleteAssistantRequest,
): string {
  return JSON.stringify(
    DeleteAssistantRequest$outboundSchema.parse(deleteAssistantRequest),
  );
}
